import bizNodeModel from '../../bizNodeModel.mjs'
import SsType from './SsType.mjs'
import TerminalType from './TerminalType.mjs'

export default bizNodeModel({
    ssUserCode: {
        name: () => '子系统代码',
        required: () => true,
    },

    ssName: {
        name: () => '子系统名称',
        required: () => true,
    },

    isUi: {
        disabled: (map, node) => node.data.pkid,
        name: () => '子系统类型',

        readableValue: (map, node) => {
            const {isUi} = node.data

            if (isUi) {
                const match = SsType.find(e => isUi === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: () => true,
    },

    ssDesc: {
        name: () => '子系统描述',
    },

    terminalType: {
        disabled: (map, node) => node.data.pkid,
        hidden: (map, node) => '1' !== node.data.isUi,
        name: () => '终端类型',

        readableValue: (map, node) => {
            const {terminalType} = node.data

            if (terminalType) {
                const match = TerminalType.find(e => terminalType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },

        required: (map, node) => '1' === node.data.isUi,
    },

    devLang: {
        name: () => '开发语言',
    },

    devTechDesc: {
        name: () => '开发技术说明',
    },

    softwareDesc: {
        name: () => '软件环境说明',
    },

    hardwareDesc: {
        name: () => '硬件环境说明',
    },

    networkDesc: {
        name: () => '网络环境说明',
    },

    deployIp: {
        name: () => '部署 IP',
    },

    deployDesc: {
        name: () => '部署环境说明',
    },
})
